module.exports = __webpack_public_path__ + "static/media/strawberry.f50934c7.svg";